import 'babel-polyfill';
import Vue from 'vue';
import ComponentTranslate from '@/libs/componentTranslatePlugin';
import VueCookies from 'vue-cookies';
import FlagIcon from 'vue-flag-icon'
import App from './App.vue';
import router from './router';
import store from './store/store';
import vuetify from './plugins/vuetify';
import i18n from './i18n';
import { EventBus, EVENTS } from './libs/eventBus';
import Api from './api'

Vue.config.productionTip = false;
Vue.use(VueCookies);
// set default config
Vue.$cookies.config('30d');
let api = new Api(store, i18n)

const isAuthenticated = function (myStore, myCookies) {
  const cookie = myCookies.get('gdpr');

  if (!cookie) {
    // Clear the current state, if the cookie is not allowed
    myStore.commit('clearState');
  }

  return myStore.getters.token() != null;
};

// Setup route guard
router.beforeEach((to, from, next) => {
  if (to.meta.requiresAuthentication && !isAuthenticated(store, Vue.$cookies)) {
    next({ name: 'login' });
  } else {
    next();
  }
});

// remove that eventbus thingy as fast as possible
router.afterEach((to, from, next) => {
  EventBus.$emit(EVENTS.ROUTE_PUSHED);
});

Vue.use(FlagIcon);
Vue.use(ComponentTranslate);

new Vue({
  router,
  store,
  vuetify,
  api,
  i18n,
  render: (h) => h(App),
}).$mount('#app');
// default locale 'de' set
i18n.locale = 'de'
